import { Component, OnInit, Input } from '@angular/core';
import { DateSlot } from 'src/app/model/dateslot.model';
import { DatePeriodEditComponent } from '../date-period-edit/date-period-edit.component';
import { Instructor } from 'src/app/model/instructor.model';
import { DeleteConfirmationDialog } from '../../delete-confirmation/delete-confirmation.dialog';
import { InstructorService } from 'src/app/service/instructor.service';
import { MatDialog } from '@angular/material';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-date-slots',
  templateUrl: './date-slots.component.html',
  styleUrls: ['./date-slots.component.css']
})
export class DateSlotsComponent implements OnInit {
  @Input() instructor: Instructor;
  removable = true;

  constructor(public dialog: MatDialog, private instructorService: InstructorService, private datePipe: DatePipe) {}

  ngOnInit() {}

  removeDateSlot(dateSlot: DateSlot) {
    const index = this.instructor.dateSlotsAvailable.indexOf(dateSlot);
    if (index >= 0) {
      const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
        width: '300px',
        data: {
          title: `DELETE ${this.instructor.user.name} available period`,
          message: `Are you sure you want to delete period from
          ${this.datePipe.transform(dateSlot.start, 'dd.MM.yy')} to ${this.datePipe.transform(dateSlot.end, 'dd.MM.yy')}`,
          key: '',
          enterKeyToConfirm: false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.remove(dateSlot, index);
        }
      });
    }
  }

  remove(dateSlot: DateSlot, index: number) {
    if (this.instructor.user.id > 0) {
      this.instructorService.deleteDateAvailable(this.instructor.user.id, dateSlot.id).subscribe(data => {
        if (data) {
          this.instructor.dateSlotsAvailable.splice(index, 1);
        }
      });
    } else {
      this.instructor.dateSlotsAvailable.splice(index, 1);
    }
  }

  addTimeSlot() {
    const dialogRef = this.dialog.open(DatePeriodEditComponent, {
      width: '300px',
      data: new DateSlot(0, this.instructor.user.id, new Date(), new Date())
    });
    dialogRef.afterClosed().subscribe(result => {
      const newDateSlot = result as DateSlot;
      if (newDateSlot != null) {
        this.add(newDateSlot);
      }
    });
  }

  add(newDateSlot: DateSlot) {
    if (this.instructor.user.id > 0) {
      this.instructorService.addDateAvailable(this.instructor.user.id, newDateSlot).subscribe(data => {
        newDateSlot = data as DateSlot;
        if (newDateSlot != null) {
          this.instructor.dateSlotsAvailable.push(newDateSlot);
        }});
    } else {
      this.instructor.dateSlotsAvailable.push(newDateSlot);
    }
  }

  editDateSlot(dateSlot: DateSlot) {
    const dialogRef = this.dialog.open(DatePeriodEditComponent, {
      width: '300px',
      data: { ...dateSlot }
    });
    dialogRef.afterClosed().subscribe(result => {
      const updatedDateSlot = result as DateSlot;
      if (updatedDateSlot != null) {
        this.edit(dateSlot, updatedDateSlot);
      }
    });
  }

  edit(dateSlot: DateSlot, updatedDateSlot: DateSlot) {
    if (this.instructor.user.id > 0) {
      this.instructorService.updateDateAvailable(this.instructor.user.id, updatedDateSlot).subscribe(data => {
        updatedDateSlot = data as DateSlot;
        if (updatedDateSlot != null) {
          dateSlot.start = updatedDateSlot.start;
          dateSlot.end = updatedDateSlot.end;
        }
      });
    } else {
      dateSlot.start = updatedDateSlot.start;
      dateSlot.end = updatedDateSlot.end;
    }
  }
}
